export function Disclaimer() {
  return (
    <div className="disclaimer" role="note">
      <p className="disclaimer__text">
        This calculator provides estimates for planning purposes only. Actual battery runtime
        may vary based on environmental conditions, battery age, load characteristics, and
        other factors. Always verify with manufacturer specifications for critical applications.
      </p>
    </div>
  )
}
